import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import _ from 'lodash';
import { default_profile } from 'constants/image';
import { useDispatch } from 'react-redux';
import { communityActions } from 'store/community';
import { useRouter } from 'next/router';

var ModalMyProfile = function ModalMyProfile(_ref) {
  var closeModal = _ref.closeModal,
      user = _ref.user,
      profile = _ref.profile;
  var keywords = profile.keywords;
  var profile_image = profile.profile_picture === null ? default_profile : profile.profile_picture;
  var dispatch = useDispatch();
  var router = useRouter();

  var convertHashTag = function convertHashTag(keyword) {
    return "#".concat(keyword, " ");
  };

  var hasSNS = !_.isEmpty(profile.facebook_username) || !_.isEmpty(profile.instagram_username) || !_.isEmpty(profile.website);
  var snsList = hasSNS ? [{
    s_name: 'facebook',
    c_name: 's-facebook',
    name: profile.facebook_username,
    href: "https://www.facebook.com/".concat(profile.facebook_username)
  }, {
    s_name: 'instagram',
    c_name: 's-insta',
    name: profile.instagram_username,
    href: "https://www.instagram.com/".concat(profile.instagram_username)
  }, {
    s_name: 'website',
    c_name: 's-etc',
    name: profile.website,
    href: profile.website
  }] : [];

  var clickOtherFeeds = function clickOtherFeeds() {
    dispatch(communityActions.setCommunitySelectUser(user));
    router.push("/community/user/".concat(user.id));
    closeModal();
  };

  return /*#__PURE__*/_jsx("div", {
    className: "dimd-layer",
    children: /*#__PURE__*/_jsx("div", {
      className: "inner big-type",
      children: /*#__PURE__*/_jsxs("section", {
        className: "cnts-introduce",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "profile-w",
          children: [/*#__PURE__*/_jsx("span", {
            className: "photo",
            style: {
              backgroundImage: "url(".concat(profile_image, ")")
            }
          }), /*#__PURE__*/_jsx("em", {
            children: profile.display_name
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "keyword-w",
          children: keywords.map(function (keyword, index) {
            return /*#__PURE__*/_jsx("a", {
              children: convertHashTag(keyword)
            }, index);
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "cnts",
          children: profile.bio
        }), /*#__PURE__*/_jsx("div", {
          className: "sns-w",
          children: /*#__PURE__*/_jsx("ul", {
            children: !hasSNS ? null : /*#__PURE__*/_jsx(_Fragment, {
              children: snsList.map(function (sns, index) {
                if (sns.name !== '') return /*#__PURE__*/_jsx("li", {
                  children: /*#__PURE__*/_jsx("a", {
                    href: sns.href,
                    className: sns.c_name,
                    target: "_blank",
                    rel: "noreferrer",
                    children: sns.name
                  })
                }, index);
              })
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "ly-btn",
          children: /*#__PURE__*/_jsx("a", {
            onClick: clickOtherFeeds,
            style: {
              cursor: 'pointer'
            },
            children: "\uC791\uC131\uAE00 \uBCF4\uAE30"
          })
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          className: "btn-close",
          onClick: closeModal,
          children: /*#__PURE__*/_jsx("span", {
            children: "\uD31D\uC5C5 \uB2EB\uAE30"
          })
        })]
      })
    })
  });
};

export default ModalMyProfile;